module.exports = __webpack_public_path__ + "static/media/iconTransport.c46827c6.svg";